import { Badge, Card, Col, ListGroup, Row, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { currencyFormatter } from '../helpers/currencyFormatter';
import getStatusColor from '../helpers/getStatusColor';
import { PendingOrdersResponse } from '../types/dashboard';

const LIST_BODY_MIN_HEIGHT = 300;

interface AnalyticsProjectsProps {
  data?: PendingOrdersResponse;
  isLoading?: boolean;
}

export default function AnalyticsProjects({ data, isLoading, ...props }: AnalyticsProjectsProps) {
  const orders = data?.orders ?? [];
  const hasData = !isLoading && orders.length > 0;

  const items = orders.map(order => (
    <ListGroup.Item key={order.id}>
      <Row className="row align-items-center">
        <Col className="ms-n2">
          <h4 className="mb-1">
            <Link to={`/order/${order.id}`}>{order.orderNumber}</Link>
          </h4>
          <Card.Text className="small text-muted mb-0">{order.customerName}</Card.Text>
          <Card.Text className="small text-muted">Balance: {currencyFormatter(order.balance)}</Card.Text>
        </Col>
        <Col xs="auto">
          <Badge bg={`${getStatusColor(order.status)}-soft`}>{order.status}</Badge>
        </Col>
        <Col xs="auto">
          <span className="small text-muted">{order.productsCases} cases</span>
        </Col>
      </Row>
    </ListGroup.Item>
  ));

  return (
    <Card {...props} className="h-100">
      <Card.Header>
        <h4 className="card-header-title">Pending Orders</h4>
        <Link className="small" to="/orders/open">
          View all ({data?.totalCount ?? 0})
        </Link>
      </Card.Header>
      <Card.Body
        style={{ minHeight: LIST_BODY_MIN_HEIGHT }}
        className="d-flex align-items-center justify-content-center"
      >
        {isLoading ? (
          <Spinner animation="border" size="sm" />
        ) : hasData ? (
          <div className="w-100 align-self-start">
            <ListGroup className="list-group-flush my-n3">{items}</ListGroup>
          </div>
        ) : (
          <p className="text-muted text-center mb-0">No data available</p>
        )}
      </Card.Body>
    </Card>
  );
}
